export const EDITABLE_TABLE_EDIT_ROW = 'EDITABLE_TABLE_EDIT_ROW';
export const EDITABLE_TABLE_EDIT_ROW_RESET = 'EDITABLE_TABLE_EDIT_ROW_RESET';
export const EDITABLE_TABLE_EDIT_ROW_COMPLETE = 'EDITABLE_TABLE_EDIT_ROW_COMPLETE';
export const EDITABLE_TABLE_UPDATE_EDITABLE_ITEM = 'EDITABLE_TABLE_UPDATE_EDITABLE_ITEM';
export const EDITABLE_TABLE_SET_UPDATING = 'EDITABLE_TABLE_SET_UPDATING';
export const EDITABLE_TABLE_UPDATE_MODIFIED = 'EDITABLE_TABLE_UPDATE_MODIFIED';
export const EDITABLE_TABLE_SET_PARTIAL_UPDATE = 'EDITABLE_TABLE_SET_PARTIAL_UPDATE';
export const EDITABLE_TABLE_EDIT_ROW_PARTIALLY = 'EDITABLE_TABLE_EDIT_ROW_PARTIALLY';
export const EDITABLE_TABLE_UPDATE_ITEM_SOURCE = 'EDITABLE_TABLE_UPDATE_ITEM_SOURCE';

export function editRow(editableRowId, editableItem, updatingTimestamp) {
  return {
    type: EDITABLE_TABLE_EDIT_ROW,
    editableRowId,
    editableItem,
    updatingTimestamp,
  };
}

export function editRowPartially(editableRowId, editableItem, reserveFields, updatingTimestamp) {
  return {
    type: EDITABLE_TABLE_EDIT_ROW_PARTIALLY,
    editableRowId,
    editableItem,
    reserveFields,
    updatingTimestamp,
  };
}

export function editRowReset() {
  return {
    type: EDITABLE_TABLE_EDIT_ROW_RESET,
  };
}

export function editRowComplete() {
  return {
    type: EDITABLE_TABLE_EDIT_ROW_COMPLETE,
  };
}

export function updateEditableItem(key, value) {
  return {
    type: EDITABLE_TABLE_UPDATE_EDITABLE_ITEM,
    key,
    value,
  };
}

export function setEditItemUpdating(updatingRow, updatingTimestamp) {
  return {
    type: EDITABLE_TABLE_SET_UPDATING,
    updatingRow,
    updatingTimestamp,
  };
}

export function setEditItemModified(anyFieldModified) {
  return {
    type: EDITABLE_TABLE_UPDATE_MODIFIED,
    anyFieldModified,
  };
}

export function setEditItemPartially(partiallyUpdate) {
  return {
    type: EDITABLE_TABLE_SET_PARTIAL_UPDATE,
    partiallyUpdate,
  };
}

export function updateEditableItemSource(itemSource) {
  return {
    type: EDITABLE_TABLE_UPDATE_ITEM_SOURCE,
    itemSource,
  };
}
